import React from 'react';
import './Table.css';

const Table = ({ headers, data, renderRow }) => {
    return (
        <div className='container-table'>
            <table className="table">
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            {renderRow(item).map((cell, cellIndex) => ( //Se ha añadido el map
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
